'use strict';

var plyr = require('plyr');

module.exports = (function(window, document, undefined) {

  let players = []

  function setupVideoBlock(videoBlock) {

    const fullVideo = videoBlock.querySelector('.js-video')
    const videoLoop = videoBlock.querySelector('.js-video-loop')
    const videoPoster = videoBlock.querySelector('.js-video-poster')
    const playButton = videoBlock.querySelector(".play-button");
    const overlay = videoBlock.querySelector(".opening-title");
    const fullVideoContainer = videoBlock.querySelector('.js-video-controls')
    let player;
    let hasPlayed = false;

    if (!fullVideo) {
      return;
    }

    function swapVideo(clickedPlay = false) {
      if (clickedPlay) {
        player.play();
        overlay.classList.add('u-display-none');

        if (videoLoop) {
          videoLoop.pause()
        }

        jQuery(videoLoop || videoPoster).delay(!hasPlayed ? 500 : 0).fadeOut("fast")
        hasPlayed = true
        return;
      }

      console.log('video loop', videoLoop)

      overlay.classList.remove('u-display-none');
      if (videoLoop) {
        videoLoop.play();
      }

      player.pause();
      jQuery(videoLoop || videoPoster).fadeIn("fast")
    }

    window.addEventListener('load', function() {
      fullVideo.setAttribute('src', fullVideo.dataset.videoSrc);

      let options = {
        controls: ['play', 'progress', 'mute', 'volume', 'captions', 'fullscreen'],
        iconUrl: '/wp-content/themes/BJGG/images/svg/video.svg',
        iconPrefix: 'v',
        autoplay: false,
      };

      player = plyr.setup(fullVideoContainer, options)[0];
      players.push(player)
    })

    // Show the play button when the main video can play
    fullVideo.addEventListener('ready', function() {

      if (!playButton) {
        return;
      }

      playButton.classList.add('ready')
      playButton.classList.remove('u-opacity-0')

      fullVideoContainer.classList.remove('u-opacity-0')

      fullVideo.addEventListener('pause', function() {
        swapVideo(false)
      })

      fullVideo.addEventListener('ended', function() {
        swapVideo(false)
      })

      playButton.addEventListener('click', function() {
        swapVideo(true);
      })
    })
  }

  function init() {
    let videoBlocks = Array.prototype.slice.call(document.querySelectorAll('.video-block'))

    if (videoBlocks.length === 0) {
      return;
    }

    videoBlocks.forEach((videoBlock) => {
      setupVideoBlock(videoBlock)
    })
  }

  return {
    init: init
  };

  })(window, document);
